const primaryColor = '#651E2F'
const goldColor = '#A99483'

module.exports = {
  primaryColor,
  antd: {
    'primary-color': primaryColor,
    'link-color': primaryColor,
    'border-radius-base': '2px',
    'menu-icon-size': '20px',
    'menu-icon-margin-right': '0',
    'menu-item-color': '#A99483',
    'menu-highlight-color': '#FFFFFF',
    'menu-item-padding': '5px 10px 30px',
    'menu-item-font-size': '13px'
  },
  custom: {
    footer: {
      // backgroundColor: primaryColor,
    },
    menu: {
      display: 'flex',
      flexFlow: 'row wrap',
      justifyContent: 'space-between',
      backgroundColor: primaryColor,
      borderBottom: '0',
      padding: '0 10px'
    },
    menuItem: {
      textAlign: 'center',
      margin: '0',
      fontWeight: 'bold',
      borderBottom: '0',
    },
    menuText: {
      lineHeight: '0',
      display: 'block'
    },
    logoBox: {
      width: '100px',
      margin: '0 auto'
    },
    logoImage: {
      width: '100%'
    },
    heroBox: {
      height: '223px',
      color: '#fff',
      lineHeight: '160px',
      textAlign: 'center',
      background: '#364d79',
      marginBottom: 0,
      overflow: 'hidden'
    }
  }
}
